var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu"},[_c('ul',_vm._l((_vm.menuList),function(item){return _c('li',{key:item.id,class:{ active: _vm.activeMenu == item.id },attrs:{"data-testId":"news-menu-item"}},[_c('router-link',{attrs:{"to":`news?category=${item.id}`,"data-testId":"news-menu-link"}},[_vm._v(_vm._s(item.title))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }